import { useLocalStorage } from '@mantine/hooks';
import Login from 'pages/login';
import { createContext, useContext, useEffect, useState } from 'react';

export type User = {
  accountId: string;
};

const AuthContext = createContext<{ user: User; logout: () => void }>(null);

export const USER_LOCAL_STORAGE_KEY = 'user';
export const USER_INITIAL_VALUE = { accountId: '' };

export const AuthProvider = ({ children }): JSX.Element => {
  const [user, setUser] = useLocalStorage<User>({
    key: USER_LOCAL_STORAGE_KEY,
    defaultValue: USER_INITIAL_VALUE,
  });
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);

  useEffect(() => {
    if (!user.accountId) {
      return;
    }

    setIsLoggedIn(true);
  }, [user]);

  const login = (user: { accountId: string }) => {
    setUser(user);
    setIsLoggedIn(true);
  };

  const logout = () => {
    setIsLoggedIn(false);
    return setUser(USER_INITIAL_VALUE);
  };

  if (!isLoggedIn) {
    return <Login login={login} />;
  }

  return <AuthContext.Provider value={{ user, logout }}>{children}</AuthContext.Provider>;
};
export { AuthContext };
export const useAuth = () => {
  return useContext(AuthContext);
};
